import { Component, DestroyRef, effect, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { fromEvent } from 'rxjs';
import { AuthService } from '../../../core/services/auth.service';
import { SellerAlertsService } from '../../../core/services/seller-alerts.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './header.component.html',
  host: { class: 'contents' },
})
export class HeaderComponent {
  private readonly destroyRef = inject(DestroyRef);

  readonly mobileMenuOpen = signal(false);
  readonly accountMenuOpen = signal(false);
  readonly scrolled = signal(false);

  constructor(
    readonly authService: AuthService,
    readonly sellerAlertsService: SellerAlertsService,
    private readonly router: Router,
  ) {
    effect(() => {
      if (typeof document === 'undefined') return;
      document.body.style.overflow = this.mobileMenuOpen() ? 'hidden' : '';
    });

    this.destroyRef.onDestroy(() => {
      if (typeof document !== 'undefined') document.body.style.overflow = '';
    });

    if (typeof window === 'undefined') return;
    this.syncScrolled();
    fromEvent(window, 'scroll', { passive: true })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.syncScrolled());
  }

  toggleMobileMenu(): void {
    this.mobileMenuOpen.update((open) => !open);
  }

  closeMobileMenu(): void {
    this.mobileMenuOpen.set(false);
  }

  toggleAccountMenu(): void {
    this.accountMenuOpen.update((open) => !open);
  }

  closeAccountMenu(): void {
    this.accountMenuOpen.set(false);
  }

  logout(): void {
    this.authService.logout().subscribe({
      complete: () => {
        this.closeAccountMenu();
        this.router.navigate(['/']);
      },
    });
  }

  private syncScrolled(): void {
    this.scrolled.set(window.scrollY > 8);
  }
}
